export const ATTRIBUTE_TRANSLATIONS: Record<string, string> = {
  AC: 'AC',
  Capacity: 'Capacity',
  Color: 'Color',
  Dimensions: 'Dimensions',
  'Flight Time': 'Flight Time',
  'Includes Waiters': 'Includes Waiters',
  Material: 'Material',
  'Menu Type': 'Menu Type',
  'Parking Spots': 'Parking',
  Resolution: 'Resolution',
};

/**
 * Get the translated name for an attribute
 * Falls back to the original name if no translation is found
 */
export function getAttributeTranslation(attributeName: string): string {
  return ATTRIBUTE_TRANSLATIONS[attributeName] || attributeName;
}

/**
 * Location types for API-driven Country → City → District cascading selects.
 */
export interface LocationOption { value: string; label: string }

export const DEFAULT_COUNTRY = 'Peru';
export const DEFAULT_CITY = 'Lima';
